var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseExpandDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3413 17.6544C11.4147 17.761 11.5129 17.8481 11.6274 17.9083C11.742 17.9685 11.8695 18 11.9989 18C12.1283 18 12.2558 17.9685 12.3704 17.9083C12.485 17.8481 12.5832 17.761 12.6566 17.6544L19.8571 7.25511C19.9405 7.13517 19.9894 6.99468 19.9985 6.84891C20.0075 6.70314 19.9765 6.55766 19.9087 6.42829C19.8409 6.29891 19.739 6.19059 19.6139 6.11508C19.4889 6.03957 19.3456 5.99977 19.1995 6H4.79835C4.65262 6.0006 4.5098 6.04092 4.38526 6.1166C4.26073 6.19229 4.15918 6.30049 4.09155 6.42957C4.02392 6.55864 3.99276 6.70371 4.00142 6.84917C4.01008 6.99463 4.05823 7.13497 4.1407 7.25511L11.3413 17.6544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseExpandDownIcon);
export default __webpack_public_path__ + "static/media/collapse-expand-down-icon.24ba3fc3957843b75ea10bb665be8c7a.svg";
export { ForwardRef as ReactComponent };